import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/HomePage";
import Delay from "@/components/Delay";
import register from "@/components/register";
import registerNew from "@/components/registerNew";
import registerFace from "@/components/registerFace";
import innerRegister from "@/components/innerRegister";
import innerRegisterOk from "@/components/innerRegisterOk";
import qrCode from "@/components/qrCode";
import registerOk from "@/components/registerOk";
import demo from "@/components/demo";
import face from "@/components/face";

// 预约会议页面
import appoint from "@/components/appoint";
import End from "@/components/End";
import OrderSuccess from "@/components/OrderSuccess";
import Cancel from "@/components/Cancel";
import DelaySuccess from "@/components/DelaySuccess";
import Advertising from "@/components/Advertising";
import Initialize from "@/components/Initialize";
import canBusiness from "@/components/canBusiness";

Vue.use(Router);

export default new Router({
  routes: [
    // 初始化页面
    {
      path: "/",
      name: "initialize",
      component: Initialize
    },
    // 招商页面
    {
      path: "/canBusiness",
      name: "canBusiness",
      component: canBusiness
    },
    //首页
    {
      path: "/homePage",
      name: "homePage",
      component: HomePage
    },
    //延迟
    {
      path: "/delay",
      name: "delay",
      component: Delay
    },
    //签到
    {
      path: "/register",
      name: "register",
      component: register
    },
    //人脸识别
    {
      path: "/registerFace",
      name: "registerFace",
      component: registerFace
    },
    {
      path: "/face",
      name: "face",
      component: face
    },
    //签到
    {
      path: "/registerNew",
      name: "registerNew",
      component: registerNew
    },
    //防疫保洁签到
    {
      path: "/innerRegister",
      name: "innerRegister",
      component: innerRegister
    },
    //扫描签到
    {
      path: "/qrCode",
      name: "qrCode",
      component: qrCode
    },
    //签到成功
    {
      path: "/registerOk",
      name: "registerOk",
      component: registerOk
    },
    //防疫保洁签到成功
    {
      path: "/innerRegisterOk",
      name: "innerRegisterOk",
      component: innerRegisterOk
    },
    //预约第一个页面
    {
      path: "/appoint",
      name: "appoint",
      component: appoint
    },
    {
      path: "/end",
      name: "end",
      component: End
    },
    {
      path: "/orderSuccess",
      name: "orderSuccess",
      component: OrderSuccess
    },
    {
      path: "/delaySuccess",
      name: "delaySuccess",
      component: DelaySuccess
    },
    {
      path: "/cancel",
      name: "cancel",
      component: Cancel
    },
    //预约第一个页面
    {
      path: "/demo",
      name: "demo",
      component: demo
    },
    {
      path: "/advertising",
      name: "advertising",
      component: Advertising
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js